'use strict';
var ClinicalResourcesController = /** @class */ (function () {
    /*@ngInject*/
    function ClinicalResourcesController($scope) {
        $scope.vm.isHeroTabs = true;
        $scope.vm.config.activateLevel1Tab = 'clinical-resources';
    }
    return ClinicalResourcesController;
}());
export default ClinicalResourcesController;
//# sourceMappingURL=clinical-resources.controller.js.map